import React, { useState, useEffect, useContext } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import styled from 'styled-components';

import '../index.css';
import Header from '../components/Header';
import FooterApp from '../components/FooterApp';
import MyPageNavBar from '../components/MyPageNavBar';

import MyPageSetting from './Setting/MyPageSetting';
import MyPagePwChange from './Setting/MyPagePwChange';
import MyPageMemberInfo from './Setting/MyPageMemberInfo';
import MyPageShopLink from './Setting/MyPageShopLink';

import MyPageStatistics from './Statistics/MyPageStatistics';
import PurchaseInduceRate from './Statistics/PurchaseInduceRate';
import MyPageStatisticsByTime from './Statistics/MyPageStatisticsByTime';
import PopularContents from './Statistics/PopularContents';
import ViewContentsStatistics from './Statistics/ViewContentsStatistics';

import MyPageServiceInfo from './ServiceInfo/MyPageServiceInfo';
import MyPagePayment from './Payment/MyPagePayment';
import PaymentSuccess from './Payment/PaymentSuccess';
import MyPaymentList from './Payment/MyPaymentList';
import MyPageNotice from './Notice/MyPageNotice';
import NoticeContent from './Notice/NoticeContent';
import PaymentClose from './Payment/PaymentClose';
import PaymentSuccessForInicis from './Payment/PaymentClose';

import ContentsMaking from './ContentsManagement/ContentsMaking/ContentsMaking';
import ContentsManagement from './ContentsManagement/ContentsPosting/ContentsManagement';
import MyContentsList from './ContentsManagement/ContentsList/MyContentsList';
import ContentsPostingManagement from './ContentsManagement/ContentsPosting/ContentsPostingManagement';
import ContentDesignManagement from './ContentsManagement/ContentsPosting/ContentDesignManagement';
import PublishedContents from './ContentsManagement/ContentsPosting/PublishedContents';
import PostedContentsManagement from './ContentsManagement/ContentsPosting/PostedContentsManagement';

import PostContent from './ContentsManagement/ContentsPosting/PostContent';
import ContentPostingSetting from './ContentsManagement/ContentsPosting/ContentPostingSetting';

import AuthContext from '../contexts/AuthContext';
import { getUserDetail } from '../modules/NetworkFunction';
import useCafe24Auth from '../hooks/useCafe24Auth';
import ShopModeContext from '../contexts/ShopModeContext';

function MyPage({ history, location }) {
  const { auth } = useContext(AuthContext); // user token
  const { shopMode } = useContext(ShopModeContext);
  const [mallId, setMallId] = useState(window.localStorage.getItem('mallId'));

  const { accessToken, setCafe24AccessToken } = useCafe24Auth();

  const redirectURI = window.location.origin + '/mypage/setting';

  useEffect(() => {
    getUserDetail(
      null,
      (d) => {
        if (!window.sessionStorage.getItem('userNo')) {
          window.sessionStorage.setItem('userNo', d.user.userNo);
        }
        if (!mallId || mallId === 'null') {
          setMallId(d.user.mallId);
          window.localStorage.setItem('mallId', d.user.mallId);
        }
        if (!window.localStorage.getItem('shopNo')) {
          window.localStorage.setItem('shopNo', d.user.shopNo);
        }
      },
      () => { },
      (e) => {
        console.log(e);
      },
      auth
    );
  }, [mallId, auth]);

  useEffect(() => {
    if (shopMode === 'cafe24' && !accessToken) {
      setCafe24AccessToken(mallId, redirectURI);
    }
  }, [mallId, shopMode, setCafe24AccessToken, redirectURI, accessToken]);

  return (
    <div>
      <Header />
      <main style={{ backgroundColor: '#dddddd' }}>
        <MainDiv>
          <PageContainer>
            <MyPageNavBar />
            <Switch>
              <MainContainer>
                <Route path="/mypage/setting" component={MyPageSetting} />
                <Route path="/mypage" component={MyPageSetting} exact />
                <Route
                  path="/mypage/contents-making"
                  component={ContentsMaking}
                />
                <Route
                  path="/mypage/contents-posting-management"
                  component={ContentsPostingManagement}
                />
                <Route
                  path="/mypage/published-contents"
                  component={PublishedContents}
                />
                <Route
                  path="/mypage/contents-management"
                  component={ContentsManagement}
                />
                <Route path="/mypage/post-content" component={PostContent} />
                <Route
                  path="/mypage/content-posting-setting"
                  component={ContentPostingSetting}
                />
                <Route
                  path="/mypage/content-design-management"
                  component={ContentDesignManagement}
                />
                <Route
                  path="/mypage/contents-list"
                  component={MyContentsList}
                />
                <Route path="/mypage/statistics" component={MyPageStatistics} />
                <Route
                  path="/mypage/statistics-by-time"
                  component={MyPageStatisticsByTime}
                />
                <Route
                  path="/mypage/contents-statistics"
                  component={ViewContentsStatistics}
                />
                <Route
                  path="/mypage/popular-products"
                  component={PopularContents}
                />
                <Route
                  path="/mypage/purchase-induce-rate"
                  component={PurchaseInduceRate}
                />
                <Route
                  path="/mypage/service-info"
                  component={MyPageServiceInfo}
                />
                <Route path="/mypage/payment" component={MyPagePayment} />
                <Route path="/mypage/payment-list" component={MyPaymentList} />
                <Route
                  path="/mypage/payment-success"
                  component={PaymentSuccess}
                />
                <Route
                  path="/mypage/payment/callback"
                  component={PaymentSuccessForInicis}
                />
                <Route
                  path="/mypage/payment-close"
                  component={PaymentClose}
                />
                <Route exact path="/mypage/notice" component={MyPageNotice} />
                <Route
                  path="/mypage/notice/:noticeNo"
                  component={NoticeContent}
                />
                <Route path="/mypage/info" component={MyPageMemberInfo} />
                <Route path="/mypage/pw-change" component={MyPagePwChange} />
                <Route path="/mypage/shop-link" component={MyPageShopLink} />
                <Route
                  path="/mypage/posted-contents-management"
                  component={PostedContentsManagement}
                />
              </MainContainer>
            </Switch>
          </PageContainer>
        </MainDiv>
      </main>
      <FooterApp style={{ backgroundColor: '#dddddd' }} />
    </div>
  );
}

export default withRouter(MyPage);

const PageContainer = styled.div`
  padding-left: 93px;
  padding-right: 95px;
  background-color: #dddddd;
  display: flex;
  flex-direction: row;
  padding-top: 30px;
  justify-content: flex-start;
`;

const MainContainer = styled.div`
  width: 928px;
  border-radius: 10px;
  background-color: #fff;
  padding: 0px 70px;
  position: relative;
  border: 0.5px solid #c4c4c4;
  flex-shrink: 0;
`;

const MainDiv = styled.div`
  margin: 0 auto;
  width: max-content;
  background-color: #dddddd;
`;
